import routeName from '../constant';
// import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: '/iq-redirecting',
        name: routeName.REDIRECTING_IQ,
        component: () => import('@/views/aplCatl640and631/IQ/redirectingPage/Index.vue'),
        meta: { auth: false, metaTitle: '投資屬性問卷', leaveAlert: true, unableBack: true },
    },
    {
        path: '/invq-redirect',
        name: routeName.REDIRECT_IQ,
        component: () => import('@/views/aplCatl640and631/IQ/redirectPage/Index.vue'),
        meta: { auth: false, metaTitle: '投資屬性問卷', leaveAlert: true, unableBack: true },
    },
];

export default routes;
